import {Component, EventEmitter, input, model, Output, ViewChild} from '@angular/core';
import {CdkAccordion, CdkAccordionItem} from '@angular/cdk/accordion';
import {animate, AUTO_STYLE, state, style, transition, trigger} from '@angular/animations';
import {MatSlideToggle, MatSlideToggleChange} from '@angular/material/slide-toggle';
import {FormsModule} from '@angular/forms';
import {NgClass} from '@angular/common';

const DEFAULT_DURATION = 300;

@Component({
    selector: 'app-toggle-expansion-panel',
  imports: [
    CdkAccordion,
    CdkAccordionItem,
    MatSlideToggle,
    FormsModule,
    NgClass
  ],
    templateUrl: './toggle-expansion-panel.component.html',
    styleUrl: './toggle-expansion-panel.component.scss',
    animations: [
        trigger('collapse', [
            state('true', style({ height: AUTO_STYLE, opacity: AUTO_STYLE, display: 'inherit' })),
            state('false', style({ height: 0, opacity: 0, display: 'none' })),
            transition('false => true', animate(DEFAULT_DURATION + 'ms ease-out')),
            transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
        ]),
        trigger('rotate', [
            state('true', style({ scale: 1 })),
            state('false', style({ scale: -1 })),
            transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
            transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
        ])
    ]
})
export class ToggleExpansionPanelComponent {

  primaryText = input<string>('');

  secondaryText = input<string>('');

  indented = input<boolean>(false);

  expanded = model<boolean>(false);

  @Output() expandedChange = new EventEmitter<boolean>();

  @ViewChild(CdkAccordionItem) cdkAccordionItem: CdkAccordionItem;

  handleChange(_: MatSlideToggleChange) {
    this.cdkAccordionItem.toggle();
    this.expanded.set(!this.expanded());
    this.expandedChange.emit(this.expanded());
  }
}
